import OnlinePaymentOrderItemModelBase from '../_generated/modelBases/online-payment-order-item-model-base';

export default class OnlinePaymentOrderItemModel extends OnlinePaymentOrderItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
